import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { isTranscriptAnalyzedStatus } from "@/lib/transcriptStatus";

type Props = {
  phase: "upload" | "review";
  meetingId?: string | null;
  analysisStatus?: string | null;
};

/** A coach-call attachment is not a leader-meeting lineage grant. */
export function UnlinkedTranscriptBiNotice({ phase, meetingId, analysisStatus }: Props) {
  if (phase === "review" && (meetingId !== null || !isTranscriptAnalyzedStatus(analysisStatus))) return null;
  return (
    <Alert>
      <AlertTitle>Leadership behavior patterns need a linked leader meeting</AlertTitle>
      <AlertDescription className="space-y-2">
        <p>{phase === "upload"
          ? "Attaching a coach session organizes the coaching review, but does not add this transcript to leadership behavior patterns. Those require a selected leader meeting."
          : "This transcript can still be reviewed. It is not included in leadership behavior patterns because it has no linked leader meeting."}</p>
        {phase === "review" && <p>A coach session link does not link this transcript to a leader meeting. The leader can select the meeting in Today or Schedule and add its transcript there. This saved analysis is not replayed automatically.</p>}
      </AlertDescription>
    </Alert>
  );
}
